
import React, { useEffect } from 'react';
import { IoMdCloseCircleOutline } from "react-icons/io";

const typeColors = {
    info: 'border-blue-500 text-blue-700',
    success: 'border-green-500 text-green-700',
    warning: 'border-yellow-500 text-yellow-700',
    error: 'border-red-500 text-red-700',
};

export default function Notification({ id, message, type = 'info', onClose, duration = 3000 }) {
    useEffect(() => {
        const timer = setTimeout(() => onClose(id), duration);
        return () => clearTimeout(timer);
    }, [id, onClose, duration]);

    const colorClasses = typeColors[type] || typeColors.info;

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
            <div
                className={`relative max-w-md w-full bg-white border-l-8 ${colorClasses} px-6 py-6 rounded-xl shadow-2xl animate-fade-in transition-all duration-300 ease-out mx-4`}
            >
                {/* Close button */}
                <button
                    onClick={() => onClose(id)}
                    className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl transition-colors"
                    aria-label="Close notification"
                >
                    <IoMdCloseCircleOutline size={22} />
                </button>

                {/* Message content */}
                <div className="text-center mt-2 md:text-lg font-medium py-6 max-md:py-3">
                    {message}
                </div>
            </div>
        </div>
    );
}

